export const arrowRight = {
	className: 'icon-arrow-right',
	viewBox: '0 0 76.267001 128.96201',
	paths: ['m 0,0 35.711,0 8.763,13.914 21.841,34.715 9.952,15.85 -9.952,15.848 -21.841,34.715 -8.763,13.92 L 0,128.962 41.006,64.48 0,0 Z']
}
